// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "f86b48982f5ae5eda028353487be696b" + ".css";
};